import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function discountCodeSelected(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<string>,
) {
  state.discountCode = action.payload;
}
